import axios from "../config/axios";
import Constants from "../data/Constants";

export const getStatistics = async (filters) => {
  return await axios
    .get(Constants.ENDPOINTS.Admin.STATISTICS, {
      params: filters,
    })
    .then((res) => {
      return res.data.result;
    });
};

export const getUpcomingCourseInterests = async () => {
  return await axios
    .get(Constants.ENDPOINTS.Admin.UPCOMING_INTERESTED_COURSE)
    .then((res) => {
      return res.data.result;
    });
};
